import React from "react";


export function usePagination({rowsNum, totalCount}:{rowsNum: number, totalCount: number | null}) {
    const [request, setRequest] = React.useState<{limit?: number, offset?: number}>({limit: rowsNum, offset: undefined})
    const [currentShift, setShift] = React.useState<number>(0);
    const maxPages = totalCount ? Math.floor(totalCount/rowsNum) : null;

    React.useEffect(()=>{
        setRequest(prev=>({...prev, offset: rowsNum*currentShift}))
    }, [currentShift])


    const nextPage = () => setShift(prev=>prev+1)
    const prevPage = () => setShift(prev=>prev-1)
    return {
        limit: request.limit,
        offset: request.offset,
        maxPages,
        nextPage,
        prevPage,
        setPage: setShift,
        currPage: currentShift
    }
}
